// extracted by mini-css-extract-plugin
export default {"Promo__Section":"Promo_Promo__Section__KbbFn","Promo__Box":"Promo_Promo__Box__l1Ijm","Promo__Title":"Promo_Promo__Title__on27W"};